import { User } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { logout } from "../../services/auth.service";

export default function AccountMenu() {
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    localStorage.removeItem("userInfo");
    navigate("/", { replace: true });
  };

  const userInfo = JSON.parse(
    localStorage.getItem("userInfo") || '{"name": "Admin"}'
  );

  return (
    <div className="w-full">
      {/* Desktop User Profile Display */}
      <div className="hidden md:flex items-center space-x-3">
        <div className="relative">
          <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center border-2 border-white/30">
            <User className="h-6 w-6 text-white" />
          </div>
          <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-white"></div>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-base font-semibold text-white truncate">
            {userInfo.name || "Administrador"}
          </p>
          <p className="text-sm text-white/70">Sistema Administrativo</p>
        </div>
      </div>

      {/* Mobile Slider Profile Display */}
      <div className="md:hidden">
        <div className="flex items-center justify-between bg-white/10 rounded-xl p-3 backdrop-blur-sm">
          <div className="flex items-center space-x-3 flex-1 min-w-0">
            <div className="relative flex-shrink-0">
              <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center border-2 border-white/30">
                <User className="h-5 w-5 text-white" />
              </div>
              <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-green-500 rounded-full border border-white"></div>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-white truncate">
                {userInfo.name || "Admin"}
              </p>
              <p className="text-xs text-white/70">Online</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
